import React from "react";
import AnnualStatementForm from "./AnnualStatementForms";

const ViewAnnualStatement = () => {
    return(
        <AnnualStatementForm type="View" />
    )
}

export default ViewAnnualStatement